export default "__VITE_ASSET__DntAiZ2z__"